import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import Swal from 'sweetalert2';
import { TransactionsInternalServicesService } from '../../../../../../../src/app/shared/services/transactions-internal-services.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/shared/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { Subject, takeUntil } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { User } from 'src/core/interfaces/user';
import { Permissions } from 'src/assets/static-data/permissions';
import { PurchaseOrderService } from 'src/app/shared/services/purchase-order.service';
import { PurchaseOrderStatus } from 'src/assets/static-data/enums/purchase-order-status.enum';
import { IPurchaseOrder } from 'src/core/interfaces/IPurchaseOrder';

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.scss','../transactions.component.scss'],
  providers: [DatePipe]

})
export class PurchaseOrderComponent {
  PurchaseOrderStatus = PurchaseOrderStatus; // Expose the enum to the template
  purchaseOrder: IPurchaseOrder[];
  permissions = new Permissions();
  currentUser: User;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canCopy: boolean;
  //canAssignDrivers: boolean;
  isLoading = false
  isInactiveLoading = false;
  clicked = false;
  lastSyncDate:Date;
  filteredDataStatus:number=-1;
  currentPage = 0;
  //activeCount = 0;
  filteredDataSearch:string=null;
  isRtl:boolean;
  typingTimer: any;
  doneTypingInterval = 800; // Delay in ms

  columns: TableColumn<IPurchaseOrder>[] = [
    { label: this.translateService.instant("TRANSACTIONUMBER.TEXT"), property: 'transactionNumber', type: 'text', visible: true },
    { label: this.translateService.instant("TRANSACTIONDATE.TEXT"), property: 'transactionDate', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMERCODE.TEXT"), property: 'customerCode', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMERNAME.TEXT"), property: 'customerName', type: 'text', visible: true },
    { label: this.translateService.instant("STATUS.TEXT"), property: 'status',type:'text', visible: true },
    { label: this.translateService.instant("ACTIONS.TEXT"), property: 'actions', type: 'button', visible: true },
  ];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 250, 500,1000,5000,10000];
  dataSource: MatTableDataSource<IPurchaseOrder> | null;
  totalRows = 0;

  //selection = new SelectionModel<IVehicle>(true, []);
  searchCtrl = new UntypedFormControl();
  private destroy$ = new Subject<void>();

  //labels = aioTableLabels;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private dialog: MatDialog,
    private userService: UserService,
    private authService: AuthService, private translateService: TranslateService,
    private purchaseOrderService:PurchaseOrderService,
    //private salesOrderService: SalesOrderService,
    private router: Router,    private datePipe: DatePipe,
    private purchaseOrderInternalService:TransactionsInternalServicesService
  ) {
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }


  ngOnInit() {
    // debugger
    this.dataSource = new MatTableDataSource();

    this.getPurchaseOrders();
    this.isRtl = this.translateService.currentLang == 'ar'|| this.translateService.currentLang == 'ur'?true:false;


    this.currentUser = this.authService.currentUserValue;

    this.userService.checkPermission(this.currentUser?.id, this.permissions.CREATE_PURCHASE_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.canAdd = response.data;
    })
    this.userService.checkPermission(this.currentUser?.id, this.permissions.UPDATE_PURCHASE_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      // debugger
      this.canEdit = response.data;
    })
    this.userService.checkPermission(this.currentUser?.id, this.permissions.DELETE_PURCHASE_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.canDelete = response.data;
    })
    this.userService.checkPermission(this.currentUser?.id, this.permissions.COPY_PURCHASE_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.canCopy = response.data;
    })
  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnDestroy() {
    // Emit destroy signal to unsubscribe all
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPurchaseOrders(criteria = null){
    this.isLoading =true;
    this.purchaseOrderService.getPaginatedPurchaseOrders(this.currentPage, this.pageSize, true, criteria).subscribe(response => {
      // // debugger;
      this.isLoading = false;
      this.dataSource.data = response.data.items;
      this.dataSource.data.forEach((row) => {
     
      row.status=this.purchaseOrderInternalService.getStatusKeyFromValue(row.status,3) as PurchaseOrderStatus;

        row.transactionDate = this.datePipe.transform(row.transactionDate, 'dd/MM/yyyy');
      });

      //this.activeCount = response.data.items.length;
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = response.data.count;
      });
      console.log(response.data.items);
    });
  }

  viewRow(order:any){
    this.router.navigate(['/transactions/purchase-orders/view', order.id]);
  }

  pageChanged(event: PageEvent) {
    
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getPurchaseOrders();
  }

  createPurchaseOrder() 
  {
    this.router.navigate(['/transactions/purchase-orders/create']);

  }

  updatePurchaseOrder(order: any) {
    this.router.navigate(['/transactions/purchase-orders/edit', order.id]);
  
  }

  copySelectedRow(quotation:any){
    this.router.navigate(['/transactions/sales-orders/copy', quotation.id]);
  }

  deletePurchaseOrder(order: any) {
    // if(vehicles.some(vehicle => vehicle.isActive) == true)
    //   {
    //     Swal.fire(this.translateService.instant("CANT_DELETE_ACTIVE_ITEM.TEXT"),"", 'warning');
    //     return; 
    //   }

    Swal.fire({
      title: this.translateService.instant("ARE_YOU_SURE.TEXT"),
      text: this.translateService.instant("YOU_WONT_BE_ABLE_TO_REVERT_THIS.TEXT"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
      cancelButtonText: this.translateService.instant("CANCEL.TEXT"),
      confirmButtonText: this.translateService.instant("YES_DELETE_IT.TEXT")
    }).then(result => {
      if (result.value) {
        this.purchaseOrderService.deletePurchaseOrder(order.id).subscribe(response => {
          if(response.statusCode === 200){
            Swal.fire(this.translateService.instant("purchase-order_DELETED_SUCCESSFULLY.TEXT"),"", 'success');
            this.getPurchaseOrders();
          } else {
            Swal.fire(this.translateService.instant("SOMETHING_WENT_WRONG.TEXT"), this.translateService.instant("PLEASE_CONTACT_ADMIN.TEXT"), 'error')
          }
        })
        //vehicles.forEach(vehicle => this.selection.deselect(vehicle));
      }
    }); 
  }



  onTypingFinished(value: string) {
    console.log('Finished typing:', value);
    this.onFilterChange(value)
    // Your search/filter logic here
  }

  onKeyup(event: any) {
    // Clear the timer on every keyup to reset the delay
    clearTimeout(this.typingTimer);
    
    // Set the timer to trigger after `doneTypingInterval` ms
    this.typingTimer = setTimeout(() => {
      this.onTypingFinished(event.target.value);
    }, this.doneTypingInterval);
  }

  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    }
    this.currentPage=0;
    value = value.trim();
    value = value.toLowerCase();
    this.getPurchaseOrders(value);
    //this.dataSource.filter = value;
  }

  toggleColumnVisibility(column, event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }


  getStatusClasses(status: string):{ textClass: string; bgClass: string } | undefined{

      return this.purchaseOrderInternalService.getStatusClasses(status, 3);


  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    //const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    //return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    //this.isAllSelected() ?
      //this.selection.clear() :
      //this.dataSource.data.forEach(row => this.selection.select(row));
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  loadData(criteria = null,status) {
    //this.isLoading = true;
    this.filteredDataStatus=status;
   
  }
}
